"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotsWithBidsComponent = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var doshx_controls_web_1 = require("doshx_controls_web");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var moment_1 = __importDefault(require("moment"));
var main_1 = require("../../../../reducers/slices/main");
var react_toastify_1 = require("react-toastify");
var lots_with_bids_1 = require("../../../../api/calls/lot/v3/lots_with_bids");
var constants_1 = require("../../../../constants/constants");
var back_up_bid_1 = require("../../../../api/calls/bid/v3/back_up_bid");
var bids_for_lot_1 = require("../../../../api/calls/bid/v3/bids_for_lot");
var reject_bid_1 = require("../../../../api/calls/bid/v3/reject_bid");
var bubble_alert_notification_wav_1 = __importDefault(require("../../../../assets/sounds/bubble-alert-notification.wav"));
var sound_1 = require("../../../../reducers/slices/sound");
var lot_status_1 = require("../common/lot_status");
var socket_1 = require("../../../../socket");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
// const socket = io(process.env.API_URL ?? "", {
//   transports: ["websocket"],
//   autoConnect: false,
// });
var LotsWithBidsComponent = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    var playNewBidSound = (0, react_redux_1.useSelector)(function (state) { return state.soundState; }).playNewBidSound;
    var _a = (0, react_1.useState)([]), lotsWithBids = _a[0], setLotsWithBids = _a[1];
    var _b = (0, react_1.useState)(false), showOnlyLotsWithBids = _b[0], setShowOnlyLotsWithBids = _b[1];
    (0, react_1.useEffect)(function () {
        getLotsWithBids(mainAuction.entity_id);
        // socket.off("connect");
        // socket.on("connect", function () {
        //   // socket.emit("joinAllLotsPipes", mainAuction.entity_id);
        // });
        // socket.connect();
    }, []);
    (0, react_1.useEffect)(function () {
        socket_1.socket.off("lotStatus");
        socket_1.socket.on("lotStatus", function (data) {
            var _id = data._id, status = data.status;
            //Update the lost in the array
            var newLotsWithBids = lotsWithBids.map(function (lot) {
                if (lot._id === _id) {
                    lot.status = status;
                }
                return lot;
            });
            setLotsWithBids(__spreadArray([], newLotsWithBids, true));
        });
        socket_1.socket.off("newBid");
        socket_1.socket.on("newBid", function (data) {
            var bid = data.bid, count = data.count;
            var newLotsWithBids = lotsWithBids.map(function (lot) {
                if (lot.entity_id === bid.lot.entity_id) {
                    lot.bids.bids.unshift(bid); // add new bid to the top of the list
                    lot.bids.bids = lot.bids.bids.slice(0, 10); // get the first 10 bids
                    lot.bids.count = count;
                }
                return lot;
            });
            setLotsWithBids(__spreadArray([], newLotsWithBids, true));
            // Play the sound
            if (playNewBidSound) {
                try {
                    var audio = new Audio(bubble_alert_notification_wav_1.default);
                    audio.play();
                }
                catch (error) {
                    console.error("Failed to play sound", error);
                }
            }
            (0, react_toastify_1.toast)(react_1.default.createElement("div", { className: "flex flex-col" },
                react_1.default.createElement("div", null,
                    "New bid for lot # ",
                    bid.lot.lot_number,
                    " - ",
                    bid.lot.title),
                react_1.default.createElement("div", null,
                    "Amount: ",
                    doshx_controls_web_1.Utilities.formatMoney({ value: bid.amount, decimalPlaces: 2 }))), __assign(__assign({}, constants_1.defaultToastOptions), { autoClose: 5000 }));
        });
    }, [lotsWithBids, playNewBidSound]);
    var getLotsWithBids = function (auction_id) {
        (0, lots_with_bids_1.lots_with_bids)({
            auction_entity_id: auction_id,
        }).then(function (response) {
            if (response.data.success) {
                setLotsWithBids(response.data.content);
            }
            else {
                console.log("getLotsWithBids response.data.message", response.data.message);
            }
        });
    };
    var getBidsForLot = function (lot_id) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, bids_for_lot_1.bids_for_lot)({
                        entity_id: lot_id,
                    })];
                case 1:
                    response = _a.sent();
                    if (response.data.success) {
                        return [2 /*return*/, response.data.content];
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Failed to get bids for lot!",
                            messages: [response.data.message],
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // function determineLotsLength() {
    //   if (showOnlyLotsWithBids) {
    //     return `${Object.keys(filteredLotsWithBids).length} / ${lotsWithBids.length}`;
    //   }
    //   return lotsWithBids.length;
    // }
    var filteredLotsWithBids = lotsWithBids.filter(function (lot) {
        if (showOnlyLotsWithBids) {
            return lot.bids.bids.length > 0;
        }
        else {
            return true;
        }
    });
    var highestBidsCombined = lotsWithBids.reduce(function (acc, lot) {
        if (lot.bids.bids.length > 0) {
            acc += lot.bids.bids[0].amount;
        }
        return acc;
    }, 0);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-2" },
        react_1.default.createElement("div", { className: "flex justify-between" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Show Lots WITH Bids", value: showOnlyLotsWithBids, onChange: function () {
                        setShowOnlyLotsWithBids(!showOnlyLotsWithBids);
                    } })),
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: playNewBidSound ? pro_solid_svg_icons_1.faVolumeUp : pro_solid_svg_icons_1.faVolumeMute, size: "lg" }),
                react_1.default.createElement(doshx_controls_web_1.SwitchControl, { label: "", checked: playNewBidSound, onChange: function (v) {
                        console.log("v", v);
                        dispatch((0, sound_1.setPlayNewBidSound)(v));
                    } }))),
        react_1.default.createElement("div", { className: "bg-[#1C77F8] p-2 rounded-t-lg text-white text-center flex justify-between items-center" },
            react_1.default.createElement("div", { className: "flex flex-row space-x-2 items-center" },
                react_1.default.createElement("div", { className: "font-bold" }, "LOTS"),
                react_1.default.createElement("div", { className: "text-sm" },
                    "(",
                    (function () {
                        if (showOnlyLotsWithBids) {
                            return "".concat(Object.keys(filteredLotsWithBids).length, " / ").concat(lotsWithBids.length);
                        }
                        return lotsWithBids.length;
                    })(),
                    ")")),
            react_1.default.createElement("div", { className: "flex gap-1 items-center" },
                react_1.default.createElement("span", { className: "text-sm" }, "Highest Bids Combined:"),
                react_1.default.createElement("span", { className: "font-bold text-xl" }, doshx_controls_web_1.Utilities.formatMoney({
                    value: highestBidsCombined,
                    decimalPlaces: 2,
                })))),
        react_1.default.createElement("div", { className: "pb-4" },
            react_1.default.createElement("div", { className: "grid grid-cols-2 gap-4 p-2 pt-0 bg-white shadow-lg rounded-b-lg" }, filteredLotsWithBids.map(function (lot, index) {
                var _a, _b;
                return (react_1.default.createElement("div", { key: lot._id, className: "flex flex-col gap-0 bg-gray-100 rounded-lg pt-2 pl-2 shadow-lg" },
                    react_1.default.createElement("div", { className: "flex flex-row gap-2 pb-2" },
                        react_1.default.createElement("div", { className: "w-20 h-20 rounded-lg overflow-clip" },
                            react_1.default.createElement("img", { src: (_b = ((_a = lot.images) !== null && _a !== void 0 ? _a : [])[0]) === null || _b === void 0 ? void 0 : _b.uploaded_file_url, alt: "No Image", className: "w-full h-full object-cover" })),
                        react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-2" },
                            react_1.default.createElement("div", { className: "flex-1 flex gap-1" },
                                react_1.default.createElement("div", { className: "font-bold" },
                                    "#",
                                    lot.lot_number,
                                    " -"),
                                react_1.default.createElement("div", null, lot.title)),
                            react_1.default.createElement("div", { className: "flex p-1 rounded-md" },
                                react_1.default.createElement(lot_status_1.LotStatus, { lot_status: lot.status })))),
                    react_1.default.createElement("div", { className: "flex flex-col" },
                        react_1.default.createElement("div", { className: "border-y-2 border-gray-500 text-sm py-2 flex justify-center" },
                            "Total Bids: ",
                            react_1.default.createElement("span", { className: "font-bold pl-1" }, lot.bids.count)),
                        react_1.default.createElement("div", { className: "flex flex-col overflow-auto gap-1 pt-1 pr-2" }, lot.bids.bids && lot.bids.bids.length > 0 ? (lot.bids.bids.map(function (bid) {
                            return (react_1.default.createElement("div", { key: bid._id, className: "flex flex-row items-center gap-2 py-1 border-b border-gray-400" },
                                react_1.default.createElement("div", { className: "flex-1 flex flex-row gap-4 text-sm" },
                                    react_1.default.createElement("div", { className: "text-sm font-bold flex items-center" }, doshx_controls_web_1.Utilities.formatMoney({
                                        value: bid.amount,
                                        decimalPlaces: 2,
                                    })),
                                    react_1.default.createElement("div", { className: "flex-1 flex flex-col" },
                                        react_1.default.createElement("div", { className: "text-xs font-bold" },
                                            "#",
                                            bid.bidder.paddle_number),
                                        react_1.default.createElement("div", { className: "flex flex-row gap-1.5 text-xs" },
                                            react_1.default.createElement("div", null, bid.user.name),
                                            react_1.default.createElement("div", null, bid.user.surname)))),
                                react_1.default.createElement("div", { className: "flex flex-row items-center" },
                                    react_1.default.createElement("div", { className: "flex-1 flex flex-col items-end" },
                                        react_1.default.createElement("div", { className: "text-xs font-bold" }, (0, moment_1.default)(bid.created_at).format("HH:mm:ss")),
                                        react_1.default.createElement("div", { className: "text-xs" }, (0, moment_1.default)(bid.created_at).format("DD/MM/YYYY")))),
                                react_1.default.createElement("div", { className: "flex gap-1" },
                                    react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_solid_svg_icons_1.faBan, backgroundColor: "bg-red-400", size: "xsmall", borderColor: "border-transparent", tooltip: {
                                            label: "Reject",
                                            placement: "left",
                                            colors: {
                                                backgroundColor: "bg-bluer",
                                                textColor: "text-white",
                                            },
                                        }, onClick: function () {
                                            dispatch((0, main_1.setMessageModal)({
                                                title: "Reject Bid?",
                                                messages: ["Are you sure that you want to reject this bid?"],
                                                buttons: "yesNo",
                                                onConfirm: function () {
                                                    (0, reject_bid_1.reject_bid)({
                                                        entity_id: bid.entity_id,
                                                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            if (response.data.success) {
                                                                dispatch((0, main_1.setMessageModal)(null));
                                                                // Update the bids for the lot
                                                                getBidsForLot(lot.entity_id).then(function (bids) {
                                                                    console.log("response123", response);
                                                                    // from lotsWithBids find the lot with the same id as the lot
                                                                    var lotWithBids = lotsWithBids.find(function (l) { return l.entity_id === lot.entity_id; });
                                                                    // update the bids for the lot
                                                                    console.log("lotWithBids", lotWithBids);
                                                                    lotWithBids.bids = bids;
                                                                    setLotsWithBids(function (prev) { return __spreadArray([], prev, true); });
                                                                });
                                                            }
                                                            else {
                                                                dispatch((0, main_1.setMessageModal)({
                                                                    title: "Failed to reject bid!",
                                                                    messages: [response.data.message],
                                                                }));
                                                            }
                                                            return [2 /*return*/];
                                                        });
                                                    }); });
                                                },
                                            }));
                                        } }),
                                    react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_solid_svg_icons_1.faUp, backgroundColor: "bg-gray-300", size: "xsmall", borderColor: "border-transparent", tooltip: {
                                            label: "Back Up",
                                            placement: "left",
                                            colors: {
                                                backgroundColor: "bg-bluer",
                                                textColor: "text-white",
                                            },
                                        }, onClick: function () {
                                            dispatch((0, main_1.setMessageModal)({
                                                title: "Back Up Bid?",
                                                messages: ["Are you sure that you want to back up this bid?"],
                                                buttons: "yesNo",
                                                onConfirm: function () {
                                                    (0, back_up_bid_1.back_up_bid)({
                                                        entity_id: bid.entity_id,
                                                    }).then(function (response) {
                                                        if (response.data.success) {
                                                            dispatch((0, main_1.setMessageModal)(null));
                                                            // Update the bids for the lot
                                                            getBidsForLot(lot.entity_id).then(function (bids) {
                                                                // from lotsWithBids find the lot with the same id as the lot
                                                                var lotWithBids = lotsWithBids.find(function (l) { return l._id === lot._id; });
                                                                // update the bids for the lot
                                                                lotWithBids.bids = bids;
                                                                setLotsWithBids(function (prev) { return __spreadArray([], prev, true); });
                                                            });
                                                        }
                                                        else {
                                                            dispatch((0, main_1.setMessageModal)({
                                                                title: "Failed to back up the bid!",
                                                                messages: [response.data.message],
                                                            }));
                                                        }
                                                    });
                                                },
                                            }));
                                        } }))));
                        })) : (react_1.default.createElement("div", { className: "py-4" }, "This lot does not have any bids yet."))))));
            })))));
};
exports.LotsWithBidsComponent = LotsWithBidsComponent;
